import { Injectable } from '@angular/core';
import { SquareCategoryType } from '../../types';
import { SquareCategory } from '../store/square-category.models';

@Injectable({
    providedIn: 'root',
})
export class AdapterService {
    adaptAll(items: any[]): SquareCategory[] {
        return items.map((item) =>
            this.adaptSingle(item, SquareCategoryType.CATEGORY)
        );
    }

    adaptSingle(item: any, categoryType: SquareCategoryType): SquareCategory {
        const subCategories =
            item.sub_categories?.map((sub: any) =>
                this.adaptSingle(sub, SquareCategoryType.SUBCATEGORY)
            ) ?? item.sub_categories;

        const newItem = {
            ...item,
            categoryType,
            sub_categories: subCategories,
        };

        return newItem;
    }
}
